import { render, staticRenderFns } from "./SSOPartnerErrorDialog.vue?vue&type=template&id=67daf65e&scoped=true"
import script from "./SSOPartnerErrorDialog.vue?vue&type=script&lang=ts"
export * from "./SSOPartnerErrorDialog.vue?vue&type=script&lang=ts"
import style0 from "./SSOPartnerErrorDialog.vue?vue&type=style&index=0&id=67daf65e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67daf65e",
  null
  
)

export default component.exports